import { ResourceFields } from '../Resource/query';

export const ContactBlockFields = `
{
    title
    description
    button ${ResourceFields}
}
`;
